// Field expenses (/saha-masraflari): expense requests, analysis charts and
// visit expenses. Categories / types are stored values; the CSV stays Turkish.
const fieldExpenses = {
  page: {
    title: 'Field Expenses',
    subtitle: 'Detailed analysis and management of all field expense requests.',
  },
  actions: {
    advanced: 'Advanced Filter',
    advancedHint: 'Filter by employee, amount, date, weekday, month and year',
    csv: 'Download CSV',
    csvHint: 'Download the filtered expense requests as CSV',
    approve: 'Approve',
    reject: 'Reject',
    delete: 'Delete',
  },
  tabs: {
    label: 'Section',
    requests: 'Expense Requests',
    requestsShort: 'Requests',
    analysis: 'Analysis',
    visitsShort: 'Visits',
    visits: 'Visit Expenses',
  },
  stats: {
    total: 'Total Expenses',
    totalShort: 'Total',
    pending: 'Pending Expenses',
    pendingShort: 'Pending',
    approved: 'Approved Expenses',
    approvedShort: 'Approved',
    rejected: 'Rejected Expenses',
    rejectedShort: 'Rejected',
    average: 'Average Expense',
    averageShort: 'Average',
    people: 'Requesters',
    peopleShort: 'People',
    requests: '{{count}} requests',
    rate: '{{rate}}% rate',
  },
  status: {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
  },
  categories: {
    transport: 'Transport',
    meal: 'Meals',
    accommodation: 'Accommodation',
    supplies: 'Supplies',
    training: 'Training',
    other: 'Other',
  },
  toolbar: {
    search: 'Search employee, description or category…',
    searchShort: 'Search expenses…',
    status: 'Status',
    allStatuses: 'All',
    category: 'Category',
    allCategories: 'All',
    period: 'Period',
    ranges: {
      all: 'All Time',
      '7d': 'Last 7 Days',
      '30d': 'Last 30 Days',
      '90d': 'Last 90 Days',
      '1y': 'Last Year',
    },
    sort: 'Sort',
    sortBy: {
      createdAt: 'Date',
      amount: 'Amount',
      employeeName: 'Employee',
    },
    asc: 'Ascending',
    desc: 'Descending',
  },
  columns: {
    employeeName: 'Employee',
    actions: 'Action',
    amount: 'Amount',
    category: 'Category',
    status: 'Status',
    createdAt: 'Date',
    description: 'Description',
    receipt: 'Receipt',
  },
  table: {
    listLabel: 'Expense requests',
    empty: 'No matching expense requests',
    unknown: 'Unknown',
    rangeOf: 'of {{total}} requests',
    ofTotal: 'out of {{total}} requests',
    jump: 'Go to page',
  },
  receipt: {
    view: 'View Receipt',
    download: 'Download Receipt',
  },
  panel: {
    label: 'Selected expense request',
    heading: 'Expense request',
    rejectionReason: 'Rejection reason',
    rejectedBy: 'Rejected by',
    updatedAt: 'Last updated',
  },
  reject: {
    title: 'Reject Expense Request',
    description: 'Please explain why you are rejecting the expense request. The employee will see this.',
    reason: 'Rejection Reason',
    placeholder: 'e.g. Missing receipt, wrong amount, unapproved spending…',
    submit: 'Reject',
    rejecting: 'Rejecting…',
  },
  delete: {
    title: 'Delete the request?',
    message: 'The expense request of {{name}} will be deleted permanently.',
  },
  advanced: {
    title: 'Advanced Filtering',
    subtitle: 'Applies to the expense table, the tiles and the charts',
    all: 'All',
    status: 'Status',
    category: 'Category',
    employee: 'Employee',
    dateFrom: 'Start Date',
    dateTo: 'End Date',
    amountMin: 'Min Amount (₺)',
    amountMax: 'Max Amount (₺)',
    weekday: 'Weekday',
    month: 'Month',
    year: 'Year',
    reset: 'Reset',
    apply: 'Apply',
  },
  charts: {
    all: 'The charts use all expense requests ({{count}}).',
    filtered: 'The charts use the {{count}} filtered requests.',
    clear: 'Clear filters',
    empty: 'No data to show',
    monthly: 'Monthly Expense Trend',
    category: 'Category Breakdown',
    status: 'Status Breakdown',
    topSpenders: 'Top Requesters',
    weekly: 'Weekday Distribution',
    categoryAmount: 'Total Amount by Category',
    approved: 'Approved',
    pending: 'Pending',
    rejected: 'Rejected',
    total: 'Total',
    count: 'Requests',
    amount: 'Total Amount',
  },
  visits: {
    listLabel: 'Visit expenses',
    search: 'Search employee, expense name, center…',
    searchShort: 'Search expenses…',
    type: 'Type',
    allTypes: 'All Types',
    empty: 'No visit expenses found',
    rangeOf: 'of {{total}} records',
    ofTotal: 'out of {{total}} records',
    panelLabel: 'Selected visit expense',
    panelHeading: 'Visit expense (info)',
    untitled: 'Untitled expense',
    center: 'Center',
    attachment: 'File {{index}}',
    stats: {
      total: 'Total Visit Expenses',
      totalShort: 'Total',
      records: '{{count}} records',
      visits: 'Visits',
      visitsShort: 'Visits',
      employees: 'Employees',
      employeesShort: 'Employees',
    },
    columns: {
      employeeName: 'Employee',
      name: 'Expense Name',
      type: 'Type',
      cost: 'Cost',
      visitDate: 'Visit Date',
      information: 'Info',
      attachments: 'Files',
      createdAt: 'Added',
    },
  },
  visitTypes: {
    transportation: 'Transport',
    accommodation: 'Accommodation',
    meal: 'Meals',
    supplies: 'Supplies',
    other: 'Other',
  },
  common: {
    cancel: 'Cancel',
  },
  toast: {
    loadError: 'Error loading data.',
    visitsError: 'Error loading visit expenses.',
    approved: 'Request approved!',
    rejected: 'Request rejected.',
    reasonRequired: 'Please enter the rejection reason.',
    actionError: 'An error occurred.',
    deleted: 'Request deleted.',
    deleteError: 'Delete failed.',
    noPdf: 'PDF file not found',
    filtersApplied: 'Filters applied',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default fieldExpenses;
